export default "__VITE_ASSET__CSDSlRU3__"